/**************************************/
/* Récupération des références du DOM */
/**************************************/
const iconeMenu = document.querySelector(".menu-bars");
const elementsMenu = document.querySelector(".main-nav");
const menuMobileContainer = document.querySelector(".menu-mobile-container");
const navBarLargeScreen = document.querySelector(".header-nav_large-screen");
const headerHeight = document.querySelector("header").offsetHeight;

// Responsive BreakePoint
const windowWidthBreakePoint = 767;

/*************************************************/
/*********** fait apparaître la topbar ***********/
/*************************************************/
//topbar mobile
let scroll_position;
try {
  let vh = headerHeight;
  if (document.querySelector(".topbar-onscroll")) {
    const navBar = document.querySelector(".topbar-onscroll");
    let visible = false;
    window.addEventListener("scroll", () => {
      scroll_position = window.scrollY;
      if (scroll_position > vh / 2 && !visible) {
        navBar.classList.add("header-nav_visible");
        visible = !visible;
      }
      if (scroll_position < vh / 2 && visible) {
        navBar.classList.remove("header-nav_visible");
        visible = !visible;
      }
    });
  }
} catch (e) {
  alert(
    "Votre navigateur semble ne pas être compatible avec certaines fonctionnalités de ce site web."
  );
  console.log(e);
}

// Topbar Large screen
// Fixe la bare de navigation lorsque l'on scrolle
let fixed = false;
window.addEventListener("scroll", () => {
  scroll_position = window.scrollY;
  if (scroll_position > headerHeight && !fixed) {
    fixed = !fixed;
    navBarLargeScreen.style.opacity = "0";
    window.setTimeout(() => {
      navBarLargeScreen.classList.add("large-nav_fixed");
      navBarLargeScreen.style.opacity = "1";
    }, 0);
  } else if (
    scroll_position < headerHeight - navBarLargeScreen.offsetHeight &&
    fixed
  ) {
    navBarLargeScreen.classList.remove("large-nav_fixed");
    fixed = !fixed;
  }
});

/******************************************/
/************** Menu mobile ***************/
/******************************************/

// Création des éléments du menu mobile
let menuMobileElements;
function creerElementsMenu() {
  menuMobileElements = document.createElement("div");
  menuMobileElements.classList.add("mobile-menu");
  menuMobileElements.append(elementsMenu.querySelector("ul").cloneNode(true));
  // menuMobileElements.classList.remove("main-menu");
  menuMobileContainer.append(menuMobileElements);
  // menuMobileElements.addEventListener("click", (e) => e.stopPropagation());
}
if (!menuMobileElements) {
  creerElementsMenu();
}

let estOuvert = false;

function toogleMenu() {
  if (!estOuvert) {
    menuMobileElements.classList.add("ouvert");
    menuMobileContainer.classList.add("menu-ouvert");
  } else {
    menuMobileElements.classList.remove("ouvert");
    menuMobileContainer.classList.remove("menu-ouvert");
  }
  estOuvert = !estOuvert;
}

iconeMenu.addEventListener("click", (event) => {
  event.stopPropagation();
  // Invocation de la fonction si le menu n'existe pas
  if (!menuMobileElements) {
    creerElementsMenu();
  }
  toogleMenu();
});

// Fermer le menu si on clique à l'extérieur
window.addEventListener("click", () => {
  if (estOuvert) {
    toogleMenu();
  }
});

// Pour retirer l'affichage si la fenêtre est agrandie manuellement
window.addEventListener("resize", () => {
  if (window.innerWidth > windowWidthBreakePoint && estOuvert) {
    toogleMenu();
  }
});

/*******************************/
/************ Date *************/
/*******************************/

const dateElem = document.querySelector("#date");
const date = new Date().getFullYear();

dateElem.innerText = date;

/**************************/
/********* Scroll *********/
/**************************/

const scrollFrom = document.querySelectorAll(".scroll-to");

function scrollToHandler(e) {
  e.preventDefault();
  const scrollTo = this.getAttribute("href");
  const elem = document.querySelector(scrollTo);
  SmoothVerticalScrolling(elem, 350);
}

for (const link of scrollFrom) {
  link.addEventListener("click", scrollToHandler);
}

function SmoothVerticalScrolling(element, time) {
  let elemTop = element.getBoundingClientRect().top;
  let eAmt = (elemTop - 100) / 100;
  let curTime = 0;
  while (curTime <= time) {
    window.setTimeout(() => {
      window.scrollBy(0, eAmt);
    }, curTime);
    curTime += time / 100;
  }
}

/*******************************/
/******* Simulation prix *******/
/*******************************/

const seclectOption = document.querySelectorAll(".selectOption");
if (seclectOption) {
  let totalOptions = 0;
  for (const checkBox of seclectOption) {
    checkBox.addEventListener("click", (e) => {
      let value = parseInt(e.target.value);
      checkBox.checked ? (totalOptions += value) : (totalOptions -= value);
      afficherTotalOptions(totalOptions);
    });
  }
  const afficherTotalOptions = (value) => {
    let simplicite = 40 + value;
    let serenite = 50 + value;
    let complete = 60 + value;
    document.querySelector("#result-simplicite").innerText = simplicite + ".00";
    document.querySelector("#result-serenite").innerText = serenite + ".00";
    document.querySelector("#result-complete").innerText = complete + ".00";
  };
} else {
  console.log("aucun élément selectOption détecté");
}
